/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content[_ngcontent-%COMP%]{width:650px;max-width:100%}@media (max-width:576px){.tab-buttons[_ngcontent-%COMP%]{margin:0 15px 15px 0!important;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-wrap:wrap}.btn.btn-border-orange[_ngcontent-%COMP%], .btn.btn-full-orange[_ngcontent-%COMP%], .full-orange[_ngcontent-%COMP%]{font-size:1.4rem;margin:0}.row[_ngcontent-%COMP%]{margin:15px 0}}"];
export { styles as styles };
